module.exports = __webpack_public_path__ + "static/media/neww.51b92b1b.png";